export default __webpack_public_path__ + "static/media/primesedan_big.ac14fb43.png";